import Model, { attr } from '@ember-data/model';

import type { UserRoleName } from 'admin-panel/constants/users';

export default class SentinelRoleModel extends Model {
  @attr
  declare name: UserRoleName;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'sentinel/role': SentinelRoleModel;
  }
}
